'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function getRotateStyle(rotateLabel) {
  var rotateValue = void 0;

  if (rotateLabel === true) {
    rotateValue = '90deg';
  } else if (rotateLabel === false) {
    rotateValue = false;
  } else {
    rotateValue = rotateLabel + 'deg';
  }

  var rotateStyle = rotateValue ? { transform: 'rotate(' + rotateValue + ')' } : {};

  return rotateStyle;
}

exports.default = getRotateStyle;